import { Box, Typography } from '@mui/material';
import { MatchingPropertieShow } from '../../../components/exo/matching-properties/MatchingPropertieShow';
import { useTranslation } from 'react-i18next';

export const LeadProperties = ({ properties }) => {
  const { t } = useTranslation();
  if (!properties || !properties?.length) return;
  return (
    <Box>
      <Typography fontWeight={600}>{t('Purchasing profile')}</Typography>
      <Box className="flex flex-col pl-2">
        {properties?.map((property) => (
          <MatchingPropertieShow key={property.id} property={property} isLead />
        ))}
      </Box>
    </Box>
  );
};
